import React from "react";
import {
 Box,
 Heading,
 SimpleGrid,
 Flex,
 Text,
 List,
 ListItem,
 ListIcon,
 Icon,
} from "@chakra-ui/react";
import {
 Wifi,
 Home,
 BookOpen,
 Coffee,
 Utensils,
 Bus,
 Library,
 Server,
 ChevronRight,
} from "lucide-react";

// Map of facility names to icons
const facilityIcons = {
 WiFi: Wifi,
 Hostel: Home,
 Library: Library,
 Cafeteria: Coffee,
 Mess: Utensils,
 Transport: Bus,
 Labs: Server,
 Classrooms: BookOpen,
 // Default to BookOpen for any unmatched facilities
};

const FacilityItem = ({ name }) => {
 const IconComponent = facilityIcons[name] || BookOpen;

 return (
  <Flex align="center" mb={2}>
   <Icon as={IconComponent} mr={2} color="blue.500" />
   <Text>{name}</Text>
  </Flex>
 );
};

const FacilitiesSpecializationsSection = ({ facilities, specializations }) => {
 const hasFacilities = facilities && facilities.length > 0;
 const hasSpecializations = specializations && specializations.length > 0;

 if (!hasFacilities && !hasSpecializations) {
  return null;
 }

 return (
  <Box mb={8}>
   <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
    {/* Facilities Section */}
    {hasFacilities && (
     <Box p={5} bg="gray.50" borderRadius="md" boxShadow="sm">
      <Heading as="h3" size="md" mb={4}>
       Facilities
      </Heading>

      <Box>
       {facilities.map((facility, index) => (
        <FacilityItem key={index} name={facility} />
       ))}
      </Box>
     </Box>
    )}

    {/* Specializations Section */}
    {hasSpecializations && (
     <Box p={5} bg="gray.50" borderRadius="md" boxShadow="sm">
      <Heading as="h3" size="md" mb={4}>
       Specializations
      </Heading>

      <List spacing={2}>
       {specializations.map((specialization, index) => (
        <ListItem key={index} display="flex">
         <ListIcon as={ChevronRight} color="blue.500" marginTop="0.3em" />
         {specialization}
        </ListItem>
       ))}
      </List>
     </Box>
    )}
   </SimpleGrid>
  </Box>
 );
};

export default FacilitiesSpecializationsSection;
